import React from 'react';
import './Other.css';

class Other extends React.Component {
  render() {
    return (
      <div class="Other">
        <h2>404</h2>
        <h5>Что то пошло не так...</h5>
      </div>

    );
  }
}

export default Other;
